import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * React Router does not act on the URL fragment, so the nav's "/#features"
 * links used to land on the top of the home page and stop there. Those anchors
 * are real destinations — Google can surface them as a "jump to" link — so the
 * fragment needs to actually scroll.
 *
 * No hash means a normal page change: go back to the top.
 */
const ScrollToHash = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      return;
    }

    // Wait a frame so the routed page has mounted before we look for the id.
    const id = decodeURIComponent(hash.slice(1));
    const frame = window.requestAnimationFrame(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    return () => window.cancelAnimationFrame(frame);
  }, [pathname, hash]);

  return null;
};

export default ScrollToHash;
